export { default as SearchModal } from './searchModal'



// WEBPACK FOOTER //
// ./src/modules/searchModal/index.js